import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import DropdownList from '../../shared/styledComponents/DropdownList';

export default InjectedStyledComponent(DropdownList, 'iconDropdown', ['list']);